import React, { useState } from "react";
import "./Nav.css";

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false); // Close menu after clicking
  };

  return (
    <div className="navbar">
      <div className="title">Antonio.dev</div>

      {/* Show the outside burger only when the menu is closed */}
      {!isMenuOpen && (
        <div className="burger" onClick={toggleMenu}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      )}

      {/* Navigation Menu */}
      <ul className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
        {/* Close Burger Icon inside the menu */}
        <div className="close-burger" onClick={toggleMenu}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
        <li onClick={() => scrollToSection("home")}>Home</li>
        <li onClick={() => scrollToSection("experience")}>Experience</li>
        <li onClick={() => scrollToSection("skills")}>Skills</li>
        <li onClick={() => scrollToSection("about")}>About me</li>
        <a href="mailto:antojunioralfa77@gmail.com" className="nav-connect-mobile">
          Let's Connect!
        </a>
      </ul>

      <a href="mailto:antojunioralfa77@gmail.com" className="nav-connect">
        Let's Connect!
      </a>

      {/* Dimmed Overlay */}
      {isMenuOpen && <div className="nav-overlay" onClick={toggleMenu}></div>}
    </div>
  );
};

export default Nav;
